import React from 'react';
import styled from 'styled-components';
import GameCard from '../components/GameCard';

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  min-height: 100vh;
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 3rem;
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 2rem;
`;

const Title = styled.h1`
  font-size: 3.5rem;
  color: #74b9ff;
  margin: 0;
  text-shadow: 0 0 10px rgba(116, 185, 255, 0.3);
  position: relative;
  display: inline-block;

  &::before {
    content: '';
    position: absolute;
    top: -20px;
    left: -40px;
    right: -40px;
    bottom: -20px;
    background: linear-gradient(45deg, transparent, rgba(116, 185, 255, 0.1), transparent);
    transform: rotate(-2deg);
    z-index: -1;
  }
`;

const Subtitle = styled.p`
  font-size: 1.2rem;
  color: #b2bec3;
  max-width: 600px;
  margin: 0 auto;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 2rem;
`;

const games = [
  {
    title: "BookSmart Quartets",
    subtitle: "A game of collection and deception",
    imageUrl: "/assets/games/booksmart-quartets.png",
    itchUrl: "https://armen138.itch.io/booksmart-quartets",
    contributors: ["armen138"],
    longDescription: `
      <p>In order to win, a player must collect 4 matching books. The book inventory of other players is visible to all, so we can make a guess on what color each is looking to acquire.</p>
      
      <h3>Special abilities</h3>
      <ul>
        <li>Rogue: pickpocket, steal a book from an opponent at short range</li>
        <li>Barbarian: stomp, intimidate an opponent into dropping all their books</li>
        <li>Mage: swap trap, drop a trap that will grab one of the opponents books when triggered</li>
      </ul>

      <h3>Game Details</h3>
      <ul>
        <li>Inventory limit: 5 items (first item dropped if acquiring a sixth)</li>
        <li>Up to 4 players can connect to a map</li>
        <li>First to collect 4 matching books wins</li>
        <li>Fixed spawn points in the corners of the map</li>
        <li>Maps are sufficiently large to prevent immediate book acquisition</li>
      </ul>

      <h3>Technical Details</h3>
      <ul>
        <li>Platforms: Windows, Linux</li>
        <li>Made with: Godot</li>
        <li>Tags: Godot</li>
        <li>Code License: MIT License</li>
        <li>Average session: A few minutes</li>
        <li>Input: Keyboard</li>
      </ul>
    `
  },
  {
    title: "Berated",
    subtitle: "A game about itself",
    imageUrl: "/assets/games/berated.png",
    itchUrl: "https://armen138.itch.io/berated",
    sourceUrl: "https://gitlab.com/armen138/berated",
    contributors: ["armen138"],
    longDescription: `
      <p>Berated is a game made for the FediJam V gamejam - the theme "self-reference". As such, the game is a game about itself.</p>
      
      <h3>Credits</h3>
      <p>The following assets were used:</p>
      <ul>
        <li><strong>Under cc0:</strong></li>
        <li>Pixel font by Kenney.nl</li>
        <li>Platformer tiles by Kenney.nl</li>
        <li>Sound Effects by SubspaceAudio</li>
        <li><strong>Under cc-by:</strong></li>
        <li>Platformer game music by CodeManu</li>
      </ul>
      <p>Additionally, characters in this game were created with Kenney's Creature-Mixer, and in accordance with its license, I hereby confirm my agreement to never use this game to promote or create non-fungible tokens (NFT's), or any crypto-currency or anything related to blockchains.</p>

      <h3>Technical Details</h3>
      <ul>
        <li>Status: Prototype</li>
        <li>Platforms: Windows, macOS, Linux</li>
        <li>Genre: Platformer</li>
        <li>Made with: Aseprite, Godot, GIMP, Krita</li>
        <li>Tags: 2D, Open Source, Pixel Art, Godot</li>
        <li>Code license: MIT License</li>
        <li>Average session: A few minutes</li>
        <li>Languages: English</li>
        <li>Input: Keyboard</li>
        <li>Source code: <a href="https://gitlab.com/armen138/berated" target="_blank" rel="noopener noreferrer">GitLab</a></li>
      </ul>
    `
  },
  {
    title: "Surge!",
    subtitle: "Disaster has struck our town - our power plant is breaking down, and producing only half the power we require!",
    imageUrl: "/assets/games/surge.png",
    itchUrl: "https://armen138.itch.io/surge",
    sourceUrl: "https://gitlab.com/armen138/surge",
    contributors: ["armen138", "iarebatman", "unbroken-unworn"],
    longDescription: `
      <p>Disaster has struck our town - our power plant is breaking down, and producing only half the power we require! You must find a way to reduce power demand, and build alternate power sources!</p>
      
      <h3>Credits</h3>
      <ul>
        <li>Game design and development by @Armen138</li>
        <li>Additional art and 3D modelling by @iarebatman</li>
        <li>Additional GUI coding and design by unbroken-unworn</li>
        <li>Some game assets used under cc0 licence by kenney.nl</li>
      </ul>

      <h3>Technical Details</h3>
      <ul>
        <li>Status: Prototype</li>
        <li>Platforms: Windows, macOS, Linux</li>
        <li>Genre: Simulation</li>
        <li>Made with: Blender, Godot, Krita</li>
        <li>Tags: 3D, City Builder, Top-Down, Godot</li>
        <li>Code license: MIT License</li>
        <li>Asset license: Creative Commons Zero v1.0 Universal</li>
        <li>Average session: A few minutes</li>
        <li>Languages: English</li>
        <li>Input: Keyboard, Mouse</li>
      </ul>
    `
  },
  {
    title: "Titan Tactics",
    subtitle: "A follow up to Pocket Tactics, Titan Tactics is inspired by the awesome tactic games of the 90s",
    imageUrl: "/assets/games/titan-tactics.png",
    itchUrl: "https://team-potato.itch.io/titan-tactics",
    sourceUrl: "https://gitlab.com/team-potato/titan_tactics",
    contributors: ["Team Potato", "cassioamara", "TheZakMan", "EidAudio", "armen138", "tiagocoelho", "Federico Calchera", "simster"],
    longDescription: `
      <p>Created in one month for the 32-bit Jam, plus an extra 3 weeks for the Spring Cleaning Jam!</p>
      <p>A follow up to Pocket Tactics, Titan Tactics is inspired by the awesome tactic games of the 90s. Fight with your allies and uncover the mysteries of the kingdoms of Tyrmyr and Skathi!</p>
      
      <h3>Controls</h3>
      <p><strong>Dualshock controls:</strong></p>
      <ul>
        <li>D-Pad: Move cursor</li>
        <li>X: Accept</li>
        <li>O: Cancel</li>
        <li>Square: Menu/End turn</li>
        <li>Triangle: Swap character</li>
        <li>L1/R1: Rotate camera</li>
        <li>Options: Pause</li>
      </ul>
      
      <p><strong>Keyboard controls:</strong></p>
      <ul>
        <li>Arrow keys: Move cursor</li>
        <li>X: Accept</li>
        <li>Z: Cancel</li>
        <li>S: Menu/End turn</li>
        <li>A: Swap character</li>
        <li>Q/E: Rotate camera</li>
        <li>Enter: Pause</li>
      </ul>

      <h3>Technical Details</h3>
      <ul>
        <li>Status: In development</li>
        <li>Platforms: Windows, macOS, Linux</li>
        <li>Genre: Strategy, Role Playing</li>
        <li>Made with: Aseprite, Godot, FL Studio</li>
        <li>Tags: 32-bitjam, Open Source, Pixel Art, ps1, Retro, Strategy RPG, Tactical RPG, Turn-based, Godot</li>
        <li>Average session: About an hour</li>
        <li>Languages: English</li>
        <li>Input: Keyboard, Playstation controller</li>
      </ul>
    `
  },
  {
    title: "Do It Later",
    subtitle: "Brutus is Ready! Will you fight? Or do it later...",
    imageUrl: "/assets/games/do-it-later.png",
    itchUrl: "https://armen138.itch.io/do-it-later",
    contributors: ["armen138"],
    longDescription: `
      <p><strong>Brutus is Ready!</strong></p>
      <p>Will you fight? I mean, you don't have to, Brutus will still be ready tomorrow. I mean eventually, you'll have to take care of Brutus, that's a given. But it doesn't have to be right now. Why not slap some of his minions around first? Just to get in the mood.</p>
      
      <h3>How to play</h3>
      <ul>
        <li>WASD: Move</li>
        <li>Mouse: Aim and fire</li>
      </ul>

      <h3>Technical Details</h3>
      <ul>
        <li>Status: Released</li>
        <li>Platforms: HTML5, Windows, macOS, Linux</li>
        <li>Genre: Shooter, Action</li>
        <li>Made with: Godot</li>
        <li>Tags: 2D, low-effort-jam, Godot</li>
      </ul>
    `
  },
  {
    title: "Pocket Tactics",
    subtitle: "Strategy RPG Gameboy demake in 4 shades of green!",
    imageUrl: "/assets/games/pocket-tactics.gif",
    itchUrl: "https://team-potato.itch.io/pocket-tactics",
    sourceUrl: "https://gitlab.com/team-potato/pocket_tactics",
    contributors: ["Team Potato", "Feorag", "EidAudio", "armen138", "cassioamara", "Froggy_Chair", "moawling"],
    longDescription: `
      <p>Created for the GBJAM 8!</p>
      
      <h3>Controls</h3>
      <p><strong>Keyboard:</strong> X to accept, Z to cancel.</p>
      <p><em>Note: The in game tutorials will still refer to A and B buttons</em></p>
      <p>B = keyboard key Z</p>
      <p>A = keyboard key X</p>
      <p><strong>Gamepad:</strong> A to accept, B to cancel.</p>

      <h3>How to play</h3>
      <p>Start by choosing your characters. First you only have yourself, but later your party will grow. Place characters to your advantage given the level you face.</p>
      
      <p>Each character has a certain amount of movement points which can be split into multiple actions. An action for a character consists of either attacking an enemy, walking or guarding. A character cannot both attack and guard during the same turn.</p>

      <p>There are three types of units in Pocket Tactics and each one has an advantage over the other:</p>
      <ul>
        <li>The Sword beats the Bow</li>
        <li>The Bow beats the Wand</li>
        <li>The Wand beats the Sword</li>
      </ul>

      <p>Recruitment is necessary in order to get a team full of diverse units. Start by whittling an opponent down to a low enough health. There will be an icon to indicate they want to talk. Walk up to them and select "Speak". You will need to persuade them. Each enemy is different, so choose your answers wisely!</p>

      <p>During your turn, you can press [Z on keyboard] and change which character to control by pressing the directions. When a character has finished their moves for that turn, they will not be available.</p>

      <h3>Technical Details</h3>
      <ul>
        <li>Status: Released</li>
        <li>Platforms: HTML5, Windows, macOS, Linux</li>
        <li>Genre: Role Playing</li>
        <li>Made with: Aseprite, Godot</li>
        <li>Tags: Game Boy, Open Source, Pixel Art, Retro, Singleplayer, Story Rich, Strategy RPG, Tactical, Tactical RPG, Turn-based Strategy, Godot</li>
        <li>Average session: A few hours</li>
        <li>Languages: English</li>
        <li>Input: Keyboard, Gamepad (any)</li>
      </ul>
    `
  },
  {
    title: "Tiny Tactics",
    subtitle: "Strategy turn-based combat in 64 pixels!",
    imageUrl: "/assets/games/tiny-tactics.gif",
    itchUrl: "https://team-potato.itch.io/tiny-tactics",
    sourceUrl: "https://gitlab.com/team-potato/tiny_tactics",
    contributors: ["Team Potato", "cassioamara", "armen138", "General UwU", "EidAudio"],
    longDescription: `
      <p>Created in 2 weeks for the Lowrez Game Jam 2020!</p>
      
      <p>Choose from one of three classes and use your class's advantage over another to plan the best route of attack and find a balance between health and damage. Each class is strong against one and weak against another, so recruiting weakened enemies to increase the diversity of classes on a team is crucial.</p>

      <h3>Story</h3>
      <p>After the collapse of human civilization, rogue warriors fight for scraps on the surface, fighting for what few remnants they can find from the old world, and sheltering in caves from the chemically modified rain that pours like thick soup onto the landscape below.</p>

      <p>~2075, global warming becomes basically irreversible, and the ice caps begin melting way faster and raising the water levels way higher. By 2090, half of the world is under water. However, the humans figure out a plan - they create a chemical to make the water thicker, and thus slow its ability to cover the land.</p>

      <p>However, that chemical also increased the nutrient levels of water and has a crazy effect on plants, which makes them grow super fast. So the half of the world that's left starts getting rapidly overrun with plant life, and roots through the ground basically make cities and largely civilized areas unstable - mini earthquakes literally caused by plants growing through the ground essentially destroy most buildings. At this point, humanity resolves to create caves underground and live there, away from the increasing temperatures above ground and the plants that continue to skyrocket.</p>

      <h3>Controls</h3>
      <p><em>(Reload page to clear your progress and start from level 1!)</em></p>
      
      <p><strong>Keyboard:</strong></p>
      <ul>
        <li>X or Enter: OK</li>
        <li>Z or Esc: Back</li>
        <li>C or Space: Go to current character</li>
        <li>Arrows or H/J/K/L: move cursor</li>
      </ul>

      <p><strong>Xbox gamepad:</strong></p>
      <ul>
        <li>A: OK</li>
        <li>B: Back</li>
        <li>Y: Go to current character</li>
        <li>D-pad: move cursor</li>
      </ul>

      <h3>Technical Details</h3>
      <ul>
        <li>Status: Released</li>
        <li>Platforms: HTML5, Windows, macOS, Linux</li>
        <li>Genre: Strategy, Role Playing</li>
        <li>Made with: Aseprite, Godot</li>
        <li>Tags: 2D, LOWREZJAM, Open Source, Pixel Art, Tactical, Turn-based Strategy, Godot</li>
        <li>Code license: MIT License</li>
        <li>Average session: About a half-hour</li>
        <li>Languages: English</li>
        <li>Input: Keyboard, Gamepad (any)</li>
      </ul>
    `
  },
  {
    title: "Bathroom Escape",
    subtitle: "Entry for Taku's Mini Jam",
    imageUrl: "/assets/games/bathroom-escape.png",
    itchUrl: "https://armen138.itch.io/bathroom-escape",
    contributors: ["armen138"],
    longDescription: `
      <p>This is my entry to #TakuJam, using the theme "Rubber Duck".</p>
      
      <h3>Technical Details</h3>
      <ul>
        <li>Status: Released</li>
        <li>Platforms: Windows</li>
        <li>Genre: Puzzle</li>
        <li>Made with: Unity, MagicaVoxel</li>
        <li>Tags: 3D, takujam, Voxel</li>
      </ul>

      <h3>Credits</h3>
      <p>Background music: "Time to Puzzle it Up" from <a href="https://opengameart.org/content/time-to-puzzle-it-up" target="_blank" rel="noopener noreferrer">OpenGameArt</a></p>
    `
  }
];

const HomePage: React.FC = () => {
  return (
    <Container>
      <Header>
        <TitleContainer>
          <Title>armen138.online</Title>
          <Subtitle>
            A collection of unique indie games ranging from retro-styled tactics games to quirky adventures. 
            Experience everything from PS1-inspired aesthetics to Gameboy demakes, space rescues to bathroom escapes.
          </Subtitle>
        </TitleContainer>
      </Header>
      <Grid>
        {games.map((game, index) => (
          <GameCard
            key={index}
            title={game.title}
            subtitle={game.subtitle}
            imageUrl={game.imageUrl}
            itchUrl={game.itchUrl}
            sourceUrl={game.sourceUrl}
            contributors={game.contributors}
            longDescription={game.longDescription}
          />
        ))}
      </Grid>
    </Container>
  );
};

export default HomePage; 